<template>
  <div class="animated fadeIn list-asset-category">
    <b-card v-show="showList">
      <div slot="header">Category/Group of Fixed Asset 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(lamabln)="data">
          <span v-if="(data.item.lamathn)">{{data.item.lamathn}} years</span>
          <span v-if="(data.item.lamabln)">{{data.item.lamabln}} months</span>
        </template>
        <template v-slot:cell(akum_acc)="data">
          {{data.item.akum_acc}} <span v-if="(data.item.akum_accname)">| {{data.item.akum_accname}}</span>
        </template>
        <template v-slot:cell(biaya_acc)="data">
          {{data.item.biaya_acc}} <span v-if="(data.item.biaya_accname)">| {{data.item.biaya_accname}}</span>
        </template>
        <template v-slot:cell(maintenacc)="data">
          {{data.item.maintenacc}} <span v-if="(data.item.maintenaccname)">| {{data.item.maintenaccname}}</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Category/Group of Fixed Asset - Add/Edit Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row >
          <b-col cols="6">
              <b-input-group >
                <b-input-group-prepend><label>Category/Group Name</label></b-input-group-prepend>
                <b-form-input v-model="frmdata.catgname" :state="!$v.frmdata.catgname.$error"></b-form-input>
              </b-input-group>
              <!-- <b-form-group  label-cols=3  label="Group Description" >
                  <b-form-input v-model="frmdata.uraian" ></b-form-input>
              </b-form-group> -->
              <b-input-group >
                <b-input-group-prepend><label>Depreciation Periode</label></b-input-group-prepend>
                  <b-form-input  v-model="frmdata.lamathn" type="number" ></b-form-input>
                  <b-input-group-append>
                    <span class="input-group-text">Year</span>
                  </b-input-group-append>
                  <b-form-input  v-model="frmdata.lamabln" type="number" ></b-form-input>
                  <b-input-group-append>
                    <span class="input-group-text">Month</span>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Fixed Asset Acc.</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.kodeaccInfo" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuCoa('kodeacc')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Depreciation Accumulatian Acc.</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.akum_accInfo" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuCoa('akum_acc')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Depreciacion Expense Acc.</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.biaya_accInfo" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuCoa('biaya_acc')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Maintenance Expense Acc.</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.maintenaccInfo" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuCoa('maintenacc')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Manage by Department</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.departemen" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuDeptShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
          </b-col>
          <b-col cols="6">
            <h5>Fixed Asset Group Account</h5>
                <b-table
                    class="mb-0"
                    ref="tblApLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="apLines.items"
                    :fields="apLines.fields"
                    :current-page="apLines.page"
                    :per-page="apLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" class="text-danger" @click="delApLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                            <b-button size="sm" class="ml-3" @click="addApLines" >Add Account</b-button>       
                    </b-col>                   
                </b-row>

          </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuDeptShow" size="lg" :hide-footer="true" title="List of Department" :centered="true">
            <lku-department @click="onSelectLkuDept"></lku-department>
        </b-modal>        

  </div>
</template>

<style lang="scss">
  .list-asset-category {
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 200px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
  }
</style>

<script>
import lkuCoa from "../lookup/lkuCoa";
import lkuDepartment from "../lookup/lkuDepartment";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import category from "../../apis/fa_category";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuCoa, lkuDepartment},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        catgname: { required },
        // uraian: { required },
        // lamathn: {required : (function() {
        //         if ((this.frmdata.lamabln || 0) != 0) {
        //             return true;
        //         } else if ((this.frmdata.lamathn || 0)==0){
        //             return false;
        //         } else return true;
        //     })},
        // lamabln: {required : (function() {
        //         if ((this.frmdata.lamathn || 0) != 0) {
        //             return true;
        //         } else if ((this.frmdata.lamabln || 0)==0){
        //             return false;
        //         } else return true;
        //     })},
        // akum_acc: { required },
        // biaya_acc: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      lkuCoaShow:false,
      lkuCoaCaller:'adv',
      lkuDeptShow:false,
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{catgname: '',uraian: '', akum_acc: '', biaya_acc: '', maintenacc:'', departid:'', departname:'', lamabln:'', lamathn:'' },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
        apLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "kodeacc",
                    label: "Kode Account",
                },
                {
                    key: "namaacc",
                    label: "Nama Account"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 100,
            total: 0,
        },
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "catgname",
            label: "Category/Group Name",
            sortable: true
          },
          {
            key: "lamabln",
            label: "Depreciation Period",
          },
          {
            key: "akum_accInfo",
            label: "Depreciation Accumulation Account",
            sortable: true
          },
          {
            key: "biaya_accInfo",
            label: "Depreciation Expense Account",
            sortable: true
          },
          {
            key: "maintenaccInfo",
            label: "Maintenance Expense Account",
            sortable: true
          },
          {
            key: "departname",
            label: "Manage By Department",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
            tdClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await category.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.apLines.items=[];
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      // this.frmdata.grouplama = data.groupname;
      let _selected;
      this.frmdata.kodelama = data.catgid;
      try {
        if (data.kodeacc) {
          _selected = await crud.findcoa({kodeacc: data.kodeacc, tahun: this.tahun});
          this.frmdata.kodeaccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        }
        // if (data.biaya_acc) {
        //   _selected = await crud.findcoa({kodeacc: data.biaya_acc, tahun: this.tahun});
        //   this.frmdata.biaya_accInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        // }
        // if (data.maintenacc) {
        //   _selected = await crud.findcoa({kodeacc: data.maintenacc, tahun: this.tahun});
        //   this.frmdata.maintenaccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        // }
        // this.frmdata.akum_accInfo=(data.akum_acc || '') + ' | ' + (data.akum_accname || '');
        // this.frmdata.biaya_accInfo=(data.biaya_acc || '') + ' | ' + (data.biaya_accname || '');
        // this.frmdata.maintenaccInfo=(data.maintenacc || '') + ' | ' + (data.maintenaccname || '');
       this.apLines.items=[];
       this.apLines.items = await category.detail(data);      
      } catch (error) {
        if (error.message) {
            toastr.error(error.message);
        } else {
            toastr.error(JSON.stringify(error));
        }                      
      }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          this.frmdata.uraian= this.frmdata.uraian || this.frmdata.catgname;
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
          const row = {};
          for (var key in this.frmdata) {
              row[key] = this.frmdata[key];
          }          
          row.accounts= this.apLines.items;          
            try {
                await category.save(row)
                this.closeFrm();              
                setTimeout(() => {
                    this.refresh();              
                }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await category.remove({tablename:'asset-category', key:this.model.catgid});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    onSelectLkuDept: async function (_selected) {
        this.frmdata.departemen = _selected.departkd.trim() + ' | ' + _selected.departemen.trim();
        this.frmdata.departid = _selected.departid;
        this.frmdata.departname = _selected.departemen;
        this.lkuDeptShow=false;
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller !='apLinesObj') {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[`${this.lkuCoaCaller}`] = _selected.kodeacc;
            this.frmdata[`${this.lkuCoaCaller}name`] = _selected.namaacc;
            if (this.lkuCoaCaller=='kodeacc') {
               const ada = this.apLines.items.find(p => p.kodeacc==_selected.kodeacc);
               if (!(ada)) {
                  const obj={kodeacc : _selected.kodeacc, namaacc:_selected.namaacc};
                  this.apLines.items.push(obj);
                  this.apLines.total=this.apLines.items.length;
               }
            }
        } else {
            const obj={kodeacc : _selected.kodeacc, namaacc:_selected.namaacc};
            this.apLines.items.push(obj);
            this.apLines.total=this.apLines.items.length;
        }
        this.lkuCoaShow=false;
    },
    addApLines : function () {
      this.showLkuCoa('apLinesObj')
    },
    delApLines: function (index) {
        if (index > -1) {
        this.apLines.items.splice(index, 1);
        }
        this.apLines.total=this.apLines.items.length;
    },    
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
